import React from 'react';
import { ActivityIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="py-12 px-6 border-t border-white/5 bg-navy-950" data-id="element-71">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-72">
        <div className="flex items-center gap-2" data-id="element-73">
          <div className="w-6 h-6 rounded-md bg-gradient-to-br from-electric to-mint flex items-center justify-center opacity-80" data-id="element-74">
            <ActivityIcon className="w-3.5 h-3.5 text-navy-950" data-id="element-75" />
          </div>
          <span className="text-slate-300 font-semibold tracking-tight" data-id="element-76">
            Pulsewave
          </span>
        </div>

        <div className="flex items-center gap-6 text-sm text-slate-500" data-id="element-77">
          <Link to="/privacy" className="hover:text-slate-300 transition-colors" data-id="element-78">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-slate-300 transition-colors" data-id="element-79">
            Terms of Service
          </Link>
          <span data-id="element-80">
            © {new Date().getFullYear()} Pulsewave. All rights reserved.
          </span>
        </div>
      </div>
    </footer>;
}